import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import {setLoadingStateDispatch} from "../../context/LoadingContext";

export function ServerErrorHandler(error, defaultMessage, snackbar, loading) {

    if (error.response && error.response.data.message) {
        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, error.response.data.message))
        loading(setLoadingStateDispatch(false))
    } else if (error.response && error.response.data && error.response.data.error) {
        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, error.response.data.error))
        loading(setLoadingStateDispatch(false))
    } else if (error.response && error.response.status) {
        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, error.response.status))
        loading(setLoadingStateDispatch(false))
    } else {
        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, defaultMessage))
        loading(setLoadingStateDispatch(false))
    }

}